type Props = {
  userName: string;
};

export function WelcomeMessage({ userName }: Props) {
  const firstName = userName.split(" ")[0] || "Usuário";

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex gap-3">
        <div className="w-8 h-8 rounded-xl bg-blue-500 text-white flex items-center justify-center text-[10px] font-bold shrink-0 shadow-sm">
          IA
        </div>
        <div className="min-w-0">
          <div className="text-[13px] font-semibold text-slate-800">
            Olá, {firstName}. Aqui a ideia é te poupar cliques.
          </div>
          <div className="mt-1 text-[12px] leading-relaxed text-slate-600">
            Eu leio o contexto da tela, aponto o que importa agora e devolvo próximo passo com CTA em vez de só conversar.
          </div>
          <div className="mt-3 grid gap-2">
            <div className="rounded-xl bg-slate-50 px-3 py-2 text-[11px] text-slate-600">
              ⚡ Use um atalho para abrir um diagnóstico operacional.
            </div>
            <div className="rounded-xl bg-slate-50 px-3 py-2 text-[11px] text-slate-600">
              🔍 Mande pergunta livre sobre processo, prazo, alerta ou cliente.
            </div>
            <div className="rounded-xl bg-slate-50 px-3 py-2 text-[11px] text-slate-600">
              🎯 Quando uma tela chamar a IA, eu tento responder como copiloto, não como chat.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
